<template>
  <!-- eslint-disable max-len -->
  <main class="u-container">
    <h1>USPS Change-of-Address<sup>®</sup></h1>
    <section class="mt-3">
      <h2>
        Mail Forwarding Instructions
      </h2>
      <p class="font-bold mt-3">
        Required Steps to Complete an Internet Change-of-Address:
      </p>
      <ol class="list-decimal pl-4 mt-1">
        <li>
          Initiate the Change-of-Address request at https://moversguide.usps.com/ from any personal computer, tablet computer, or mobile phone with access to the Internet.
        </li>
        <li>
          Make sure that you have a valid Email address and credit or debit card for identity validation before the ICOA can be processed. A {{ icoaAmountFormatted }} Verification Fee is charged for the verification of your address.
        </li>
        <li>
          Enter your credit or debit card number and billing address. Please note, we do not accept pre-paid credit or debit cards. The following credit or debit cards can be used:
          <ul class="list-disc pl-4 mt-3">
            <li>
              MasterCard®
            </li>
            <li>
              Visa®
            </li>
            <li>
              Discover®
            </li>
            <li>
              American Express®
            </li>
          </ul>
          <p class="my-3 text-normal">
            The U.S. Postal Service electronically verifies the information you entered with the bank that issued your card. This is done to verify that the address you provide matches the address record for your card. The verification fee pays for this service, which helps verify your address, and provide a secure online transaction.
          </p>
        </li>
        <li>
          After you have completed your Change-of-Address online, an Email confirmation is automatically sent.
        </li>
        <li>
          You will receive a Confirmation Notification Letter and a Welcome Kit at your new address. This letter allows you to verify the Change-of-Address information on file with your Post Office.
        </li>
      </ol>

      <p class="font-bold mt-3">
        Classes of mail:
      </p>
      <ul class="list-disc pl-4 mt-1">
        <li>
          <span class="font-bold">First-Class™ Mail®, Priority Mail®, Priority Mail Express®:</span> All forwarded for 12 months at no charge.
        </li>
        <li>
          <span class="font-bold">Periodicals:</span> Forwarded for 60 days at no charge (includes newspapers and magazines).
        </li>
        <li>
          <span class="font-bold">USPS Marketing Mail® (also referred to as Standard Mail®):</span> Not forwarded unless requested by the mailer. Includes circulars, books, catalogs, and advertising mail weighing less than 16 ounces.
        </li>
        <li>
          <span class="font-bold">Package Services:</span> Forwarded for 12 months. Additional forwarding postage charged (includes packages weighing 16 ounces or more not mailed using Priority Mail® service).
        </li>
        <li>
          <span class="font-bold">Special Services:</span> Certified Mail®, Collect on Delivery (COD), USPS Delivery Confirmation™, insured, Registered Mail®, Signature Confirmation™, or special handling mail is forwarded without additional special service fees when mail is being forwarded to a domestic address only. Mail is subject to the applicable postage for each specific service.
        </li>
      </ul>
      <router-link
        :to="{ name: 'disclaimer' }"
        class="c-btn mt-5"
      >
        Continue
      </router-link>
    </section>
  </main>
</template>
<script>
export default {
  computed: {
    icoaAmount() {
      return this.$store.state.config.icoaAmount / 100;
    },
    icoaAmountFormatted() {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(this.icoaAmount);
    },
  },
};

</script>
